export default "__VITE_ASSET__BSMnoZaC__"